import { Alert, Button } from "react-bootstrap";
import { Modal } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";

const ModalAlertas = ({ modals, handlerModal }) => {

    //? ESTADOS GLOBALES
    const { alertasBloqueo, alertasNoBloqueo } = useActaDetalleStore();

    return (
        <>
            <Modal
                show={modals.includes('alertas_acta')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "alertas_acta" })}
                title={() => "Alertas sobre el acta"}
            >

                <Alert variant="danger">
                    <p className="fs-4 fw-normal">Revise los siguientes campos y de ser necesario complete para continuar</p>
                    {
                        alertasBloqueo?.length > 0 &&
                        <div>
                            <hr />
                            <p className="fw-medium fs-5 mt-3">Campos necesarios para aprobar el acta.</p>
                            <ul>
                                {
                                    alertasBloqueo.map((alerta) => (
                                        <li className="fw-medium fs-6 mt-3" key={alerta.id}>{alerta.descripcion}</li>
                                    ))
                                }
                            </ul>

                        </div>
                    }
                    {
                        alertasNoBloqueo?.length > 0 &&
                        <div>
                            <hr />
                            <p className="fw-medium fs-5 mt-3">Campos opcionales.</p>
                            <ul >
                                {
                                    alertasNoBloqueo?.map((alerta) => (
                                        <li className="fw-medium fs-6 mt-3" key={alerta.id}>{alerta.descripcion}</li>
                                    ))
                                }
                            </ul>
                        </div>
                    }

                </Alert>
                <div className="text-center">
                    <Button onClick={() => { handlerModal({ modal: false, modalName: "alertas_acta" }) }} >Confirmar</Button>
                </div>
            </Modal>
        </>
    );
}
export default ModalAlertas;